import { NgModule } from '@angular/core';
import { ApiCoreModule } from '@qtek/core/api-core';
import { MetaCoreModule } from '@qtek/libs/meta-core';

@NgModule({
  imports: [MetaCoreModule, ApiCoreModule],
  providers: [],
})
export class WebsocketsCoreModule {}
